<template>
  <div>
    <default-modal
      v-model="modalOpened"
      name="text-teplate-modal"
      :title="$t('text_template_modal_title')"
      width="md"
    >
      <template slot="header">
      </template>
      <template slot="content">
        <div class="flex justify-center q-mt-md">
          <q-btn-toggle
            v-model="position"
            toggle-color="dark"
            :options="[
              { label: $tc('text_template_top', 2), value: 'top' },
              { label: $tc('text_template_bottom', 2), value: 'bottom' },
            ]"
          />
        </div>

        <text-template-form :template="selected" :type="type" :model="model"/>

        <div v-if="templates.length > 0" class="q-pb-md">
          <q-infinite-scroll
            :handler="handleInfiniteScroll"
          >
            <text-template-entry
              v-for="(template, index) in templates"
              :key="index"
              :template="template"
              class="q-mt-md"
              @apply="templateSelected(template.content)"
              @edit="handleEdit(template)"
              @delete="handleDelete(template)"
            />
          </q-infinite-scroll>
        </div>
        <template v-else>
          <div class="row justify-center items-center col-grow">
            <div class="text-center">
              <img src="~assets/emptystates/templates_empty.svg"/>

              <h6 class="q-my-md text-faded">{{ $t('no_templates') }}</h6>
            </div>
          </div>
        </template>
      </template>
    </default-modal>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import AddTextareaBox from 'components/Invoices/Create/AddTextareaBox.vue'
  import DefaultModal from 'components/Modal/DefaultModal.vue'
  import TextTemplateEntry from 'components/TextTemplates/TextTemplateEntry'
  import TextTemplateForm from 'components/TextTemplates/TextTemplateForm'

  export default {
    name: 'TextTemplateModal',

    props: {
      model: {
        type: String,
        required: true
      },

      initialPosition: {
        validator: (val) => ['top', 'bottom'].includes(val),
        required: false,
        default: 'top'
      }
    },

    data () {
      return {
        position: 'top',
        modalOpened: false,
        showForm: false,
        selected: null
      }
    },

    methods: {
      ...mapActions([
        'fetchNextInvoiceTextTemplateChunk',
        'fetchNextQuoteTextTemplateChunk',
        'deleteInvoiceTextTemplate',
        'deleteQuoteTextTemplate',
        'createInvoiceTextTemplate',
        'createQuoteTextTemplate'
      ]),

      handleInfiniteScroll (index, done) {
        return this.isInvoice
          ? this.fetchNextInvoiceTextTemplateChunk({ done, type: this.type })
          : this.fetchNextQuoteTextTemplateChunk({ done, type: this.type })
      },

      handleDelete (template) {
        this.$q.dialog({
          title: this.$t('confirm'),
          message: this.$t('text_template_delete_confirm'),
          ok: this.$t('delete'),
          cancel: this.$t('cancel')
        }).then(() => {
          return this.isInvoice
            ? this.deleteInvoiceTextTemplate(template)
            : this.deleteQuoteTextTemplate(template)
        }).catch(() => {})
      },

      open () {
        this.position = this.initialPosition
        this.modalOpened = true
      },

      templateSelected (text) {
        this.$emit('selected', text)
        this.modalOpened = false
      },

      handleEdit (template) {
        this.selected = template
      }
    },

    computed: {
      ...mapGetters(['invoiceTextTemplates', 'quoteTextTemplates']),

      isInvoice () {
        return this.model === 'invoice'
      },

      type () {
        return `${this.model}_${this.position}`
      },

      templates () {
        return (this.isInvoice
          ? this.invoiceTextTemplates
          : this.quoteTextTemplates
        ).filter(template => template.type === this.type)
      }
    },

    components: {
      TextTemplateEntry,
      DefaultModal,
      AddTextareaBox,
      TextTemplateForm
    }
  }
</script>
